import { useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { imgUrl } from "@/lib/api";

export default function Lightbox({ images, index, onClose, onIndex }) {
  const img = images[index];
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % images.length);
      if (e.key === "ArrowLeft") onIndex((index - 1 + images.length) % images.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [index, images.length, onClose, onIndex]);

  if (!img) return null;
  const btn = "absolute top-1/2 -translate-y-1/2 p-3 bg-white/80 hover:bg-white text-[#1f402b] transition-colors";
  return (
    <div className="fixed inset-0 z-[80] bg-[#fcfbfa]/95 backdrop-blur-xl flex flex-col" data-testid="gallery-lightbox">
      <div className="flex justify-between items-center px-5 sm:px-8 h-16 font-mono-k text-[11px] text-[#5a665e]">
        <span data-testid="lightbox-counter">{index + 1} / {images.length}</span>
        <button onClick={onClose} className="p-2 text-[#1f402b]" data-testid="lightbox-close-button" aria-label="Close"><X size={20} /></button>
      </div>
      <div className="relative flex-1 flex items-center justify-center px-4 sm:px-20 pb-4 min-h-0">
        <img src={imgUrl(img.url)} alt={img.caption || "Gallery image"} className="max-h-full max-w-full object-contain" />
        {images.length > 1 && (
          <>
            <button className={`${btn} left-2 sm:left-6`} onClick={() => onIndex((index - 1 + images.length) % images.length)} data-testid="lightbox-prev-button" aria-label="Previous"><ChevronLeft size={20} /></button>
            <button className={`${btn} right-2 sm:right-6`} onClick={() => onIndex((index + 1) % images.length)} data-testid="lightbox-next-button" aria-label="Next"><ChevronRight size={20} /></button>
          </>
        )}
      </div>
      <p className="text-center pb-6 px-6 font-display italic text-lg text-[#1f402b]" data-testid="lightbox-caption">{img.caption}</p>
    </div>
  );
}
